import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import GifImg from '../assets/pixel-art-gifs.gif';

const CompanyShowcase = () => {
    return (
        <section className="bg-black border-t-[5px] border-white pt-1 pb-8 md:pb-12 overflow-hidden relative">

            <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                {/* Text Content */}
                <div className="space-y-8 z-10">
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                        className="text-3xl lg:text-4xl font-black text-white leading-tight uppercase tracking-tight"
                        style={{ fontFamily: '"Space Grotesk", sans-serif' }}
                    >
                        Patna's Premier Tech Agency <br className="hidden lg:inline" />, <br className="lg:hidden" />
                        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">Scaling Global Brands</span>
                    </motion.h2>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="text-lg text-gray-400 leading-relaxed font-light"
                        style={{ fontFamily: '"Outfit", sans-serif' }}
                    >
                        Whether you're in Kankarbagh or California, we bring world-class digital solutions to your doorstep. At <strong className="text-white">Tech Inovant</strong>, we're not just another tech agency—we're Patna's leading creative powerhouse. Whether you're a startup ready to launch or an established brand aiming to elevate, our mission is simple: turn your vision into a powerful digital reality.

                        <br /><br />
                        With years of experience, a passionate team, and a portfolio that speaks for itself, we specialize in crafting pixel-perfect websites, impactful marketing strategies, and innovative software solutions that help your business grow, scale, and thrive online.
                    </motion.p>
                </div>

                {/* GIF / Visual Content */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.8, x: 50 }}
                    whileInView={{ opacity: 1, scale: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="relative flex justify-center items-center"
                >

                    <img
                        src={GifImg}
                        alt="Tech Innovation"
                        className="relative z-10 w-full max-w-md object-contain drop-shadow-2xl"
                    />
                </motion.div>

            </div>
        </section>
    );
};

export default CompanyShowcase;
